<template>
  <el-dialog
    :title="typeof client.id !== 'undefined' ? 'Edit Client' : 'Create Client'"
    visible
    top="5vh"
    :fullscreen="isFullscreen"
    :close-on-click-modal="false"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      ref="clientForm"
      v-loading="isSaving"
      :rules="rules"
      :model="client"
      size="small"
    >
      <el-row>
        <el-col :md="24">
          <el-row :gutter="10">
            <el-col :md="24">
              <el-form-item
                label="Description"
                prop="description"
              >
                <el-input
                  v-model="client.description"
                  placeholder="Warehouse API"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :md="12">
              <el-form-item
                label="Key"
                prop="key"
              >
                <el-input
                  v-model="client.key"
                  placeholder=""
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item
                label="Secret"
                prop="secret"
              >
                <el-input
                  v-model="client.secret"
                  type="text"
                  placeholder=""
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :md="12">
              <el-form-item
                label="Access Level"
                prop="role"
              >
                <el-select
                  v-model="client.role"
                  :loading="isLoadingLevels"
                  value-key="id"
                  placeholder="Select an access level"
                  class="w-100"
                >
                  <el-option
                    v-for="level in levels"
                    :key="level.id"
                    :label="formatDisplayRole(level)"
                    :value="level"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item
                label="Generate Keys"
              >
                <el-button
                  type="primary"
                  @click.native="generateKeys"
                >
                  Generate Keys
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="typeof client.id !== 'undefined' ? updateClient() : createClient()"
      >
        {{ typeof client.id !== 'undefined' ? 'Save' : 'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import generateApiKey from 'generate-api-key'

export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    client: {
      type: Object,
      required: true
    },
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      levels: [],
      isSaving: false,
      isFullscreen: false,
      isLoadingLevels: false,
      rules: {
        description: [
          { required: true, message: 'Client Description is required', trigger: 'blur' }
        ],
        key: [
          { required: true, message: 'Client Key is required', trigger: 'blur' }
        ],
        secret: [
          { required: true, message: 'Client Secret is required', trigger: 'change' }
        ],
        level: [
          { required: true, message: 'Client Level is required', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.loadLists()
  },
  methods: {
    loadLists () {
      // Roles
      this.isLoadingRoles = true
      this.$sdk.level.list(builder => {
        builder.page = 1
        builder.limit = 1000
        builder.order = 'uuid:asc'
      }).then(res => {
        this.levels = res
      })
        .finally(() => {
          this.isLoadingLevels = false
        })
    },
    generateKeys () {
      this.client.key = generateApiKey({ method: 'bytes', prefix: 'of3' })
      this.client.secret = generateApiKey({ method: 'bytes', length: 64 })
    },
    createClient () {
      this.$refs.clientForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.$sdk.client.create(this.client, builder => {
            builder.context = { account: this.accountId }
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    },
    updateClient () {
      this.$refs.clientForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.client.update(builder => {})
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    },
    formatDisplayRole (level) {
      if (level) {
        return level.description
      } else return ''
    }
  }
}
</script>

<style>

</style>
